export default {
  isLaunch: state => state.search.isLaunch,
  isLoading: state => state.search.isLoading,
  isMiniVariant: state => state.isMiniVariant,
  alerts: state => state.alerts,
  listQuestion: state => state.listSecretQuestions,
  listGender: state => state.listGender,
  timelineFixed: state => state.timelineFixed,
};
